import { EclearOption } from '@enechain/eposition-proto/bfftypes/v1/contract_pb'

export type OrganizationOptionCategory = 'OPTION_1' | 'OPTION_2'

export const ECLEAR_OPTION_CATEGORY = {
  OPTION_1: 'OPTION_1',
  OPTION_2: 'OPTION_2',
} as const

/**
 * @param eclearOption EclearOption enum値
 * @returns 'OPTION_1' | 'OPTION_2'
 */
export function getOrganizationOptionCategory(
  eclearOption: EclearOption,
): OrganizationOptionCategory {
  switch (eclearOption) {
    case EclearOption.ECLEAR_OPTION_1_1:
    case EclearOption.ECLEAR_OPTION_1_2:
    case EclearOption.ECLEAR_OPTION_1_3:
      return 'OPTION_1'
    case EclearOption.ECLEAR_OPTION_2_1:
    case EclearOption.ECLEAR_OPTION_2_2:
      return 'OPTION_2'
    default:
      return 'OPTION_1'
  }
}
